import {
  CareerSiteFiltersOption as BaseCareerSiteFiltersOption,
  CareerSiteSettings,
} from 'api-clients/monolith';
import { AppContext as AppContextV2 } from 'contexts/v2/app-context';
import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { FiltersContent, FiltersContentSkeleton } from './filters-content';

interface CareerSiteFiltersOption extends BaseCareerSiteFiltersOption {
  count?: number;
}

export interface FiltersCardProps {
  brandSetting: CareerSiteSettings;
  filterOptions?: {
    jobTypes: CareerSiteFiltersOption[];
    jobHours: CareerSiteFiltersOption[];
    countries: CareerSiteFiltersOption[];
    states: CareerSiteFiltersOption[];
    cities: CareerSiteFiltersOption[];
    category: CareerSiteFiltersOption[];
    position: CareerSiteFiltersOption[];
    locationName: CareerSiteFiltersOption[];
  };
}

export function FiltersCardSkeleton() {
  return (
    <div className="flex flex-col gap-4" data-testid="filters-skeleton">
      <div className="rounded-lg border border-gray-200">
        <div className="flex items-center justify-between p-4">
          <div className="h-6 w-16 animate-pulse rounded bg-gray-200" />
          <div className="h-4 w-12 animate-pulse rounded bg-gray-200" />
        </div>
        <FiltersContentSkeleton />
      </div>
    </div>
  );
}

export function FiltersCard({ brandSetting, filterOptions }: FiltersCardProps) {
  const intl = useIntl();
  const { resetFilters, filterCounts } = useContext(AppContextV2);

  if (!filterCounts) {
    return <FiltersCardSkeleton />;
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="rounded-lg border border-gray-200">
        <div className="flex items-center justify-between p-4">
          <h2 className="text-lg font-medium text-gray-900">
            {intl.formatMessage({
              defaultMessage: 'Filters',
              description: 'Title for filters section',
            })}
          </h2>
          <button
            type="button"
            onClick={resetFilters}
            className="text-primary-600 hover:text-primary-700 text-sm font-medium"
          >
            {intl.formatMessage({
              defaultMessage: 'Clear',
              description: 'Button to clear all filters',
            })}
          </button>
        </div>
        <FiltersContent
          brandSetting={brandSetting}
          filterOptions={filterOptions}
        />
      </div>
    </div>
  );
}
